import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {TemporalFormatering, ZonedDateTimeFormat} from "../tjenester/TemporalFormatering";
import {concat, interval, Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import {ZonedDateTimeSerialisert} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {lesZonedDateTimeSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import ZonedDateTime = Temporal.ZonedDateTime;

/**
 * Formaterer ZonedDateTime instans som relativ dato.
 * Se {@link TemporalFormatering#formaterZonedDateTimeRelativ}.
 * Merk at vi returnerer en Observable, så resultatet må pipes til 'async'
 * Eksempel: {{enZonedDateTimeDato | zoneddatetime_relativ | async}}
 */
@Pipe({name: 'zoneddatetime_relativ', pure: true, standalone: true})
export class FormaterZonedDateRelativTimePipe implements PipeTransform {

    constructor(private formatering: TemporalFormatering) {
    }

    transform(datoOgKlokkeslett: ZonedDateTime | ZonedDateTimeSerialisert | null, format: ZonedDateTimeFormat = 'short'): Observable<string> {
        let zonedDateTime = (datoOgKlokkeslett instanceof ZonedDateTime) ?
          datoOgKlokkeslett : lesZonedDateTimeSerialisertOpt(datoOgKlokkeslett);
        return concat(of(null), interval(1000 * 60)) //oppdater ved instansiering, og så hvert 60. sekund
          .pipe(map(() => this.formatering.formaterZonedDateTimeRelativ(zonedDateTime, format)));
    }
}
